import React from 'react'
import './content-home.scss'
import SectionMainBanner from '../section-main-banner/section-main-banner'
import SectionYourConfidant from '../section-your-confidant/section-your-confidant'
import SectionFeaturedArticles from '../section-featured-articles/section-featured-articles'
import SectionNewLine from '../section-new-line/section-new-line'
import GeneralBanner from '../../molecules/general-banner/general-banner'
import { useStaticQuery, graphql } from 'gatsby'

const ContentHome = () => {
  const { allContentfulVConfidentHome } = useStaticQuery(
    graphql`
      query bannerMuestra {
        allContentfulVConfidentHome {
          nodes {
            paisesDeRestriccion
            node_locale
            bannerMuestraGratis {
              gatsbyImageData
              fluid {
                aspectRatio
                base64
                sizes
                src
                srcSet
              }
              file {
                url
              }
            }
            redireccionBannerMuestraGratis
          }
        }
      }
    `
  )

  const bannerInfo = allContentfulVConfidentHome.nodes.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  return (
    <>
      <SectionMainBanner />
      <SectionYourConfidant />
      <SectionFeaturedArticles />
      <SectionNewLine />
      <GeneralBanner bannerInfo={bannerInfo} color="pink" />
    </>
  )
}

export default ContentHome
